import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/briefings/[slug]/BriefingPostClient.tsx");
